import { SurveyDeployerPageResponseJSON } from './../Survey-Deployer-Page-Response-JSON';
import { HTMLDisplayComponentJSON } from './../htmlComponent/HTML-Display-Component-JSON';

export class WCPageDetailsResponseJSON extends SurveyDeployerPageResponseJSON {
    surveyID: Number;
    welcomePageText: String;
    hHTMLDisplayComponentJSONList: HTMLDisplayComponentJSON[];
    itemsPerRow:number;
    listSize:number;
    alreadySubmitted: boolean;
    alreadySaved: boolean;

    constructor() {
        super()
        this.hHTMLDisplayComponentJSONList = new Array<HTMLDisplayComponentJSON>();
    }
} 